import * as React from 'react'

import { Box, CornerIndicator } from '@factorialco/deprecated-design-system'

import DurationInput from 'modules/core/components/DurationInput'

type DurationInputProps = React.ComponentProps<typeof DurationInput>

interface DurationInputWithValidationProps extends DurationInputProps {
  completed?: boolean
}

const DurationInputWithValidation = ({ completed, ...props }: DurationInputWithValidationProps) => {
  return (
    <Box position="relative" width="full">
      <DurationInput {...props} />
      <CornerIndicator
        missing={false}
        errors={false}
        attachmentPosition="bottom right"
        missingLabel=""
        completed={completed}
      />
    </Box>
  )
}

export { DurationInputWithValidation }
